export default __webpack_public_path__ + "navigation-camera-pitch-near-maneuver-disabled-960-57820155c9f5af733f6fb002c1afedc8.webp";